const MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

export function formatEventDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()} à ${String(d.getHours()).padStart(2, "0")}h${String(d.getMinutes()).padStart(2, "0")}`;
}

export function formatShortDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return `${d.getDate()} ${MONTHS[d.getMonth()].slice(0, 4)}. ${d.getFullYear()}`;
}

export function formatRelative(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "à l'instant";
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  return formatShortDate(iso);
}

export const CURRENCIES = [
  { code: "GNF", label: "Franc guinéen (GNF)", symbol: "GNF", decimals: 0 },
  { code: "XOF", label: "Franc CFA Ouest (XOF)", symbol: "FCFA", decimals: 0 },
  { code: "EUR", label: "Euro (EUR)", symbol: "€", decimals: 2 },
  { code: "USD", label: "Dollar US (USD)", symbol: "$", decimals: 2 },
];

export function getCurrency(code) {
  return CURRENCIES.find((c) => c.code === code) || CURRENCIES[0];
}

export function formatPrice(p, currency = "GNF") {
  const n = Number(p) || 0;
  if (n === 0) return "Gratuit";
  const c = getCurrency(currency);
  const formatted = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: c.decimals,
    maximumFractionDigits: c.decimals,
  }).format(n);
  return c.code === "EUR" || c.code === "USD" ? `${formatted} ${c.symbol}` : `${formatted} ${c.symbol}`;
}

export function formatAmount(p, currency = "GNF") {
  // Always show even if 0
  const n = Number(p) || 0;
  const c = getCurrency(currency);
  const formatted = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: c.decimals,
    maximumFractionDigits: c.decimals,
  }).format(n);
  return `${formatted} ${c.symbol}`;
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
